"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTranslationTable = exports.EMPTY_TRANSLATION_TABLE = exports.APPLE_DEFAULT_LOCALE = exports.AppleLanguageType = exports.LanguageType = void 0;
const utils_1 = require("../utils/utils");
exports.LanguageType = {
    English: 'en',
    Arabic: 'ar',
    Chinese: 'zh',
    ChineseTraditional: 'zh-Hant',
    Danish: 'da',
    Dutch: 'nl',
    Finnish: 'fi',
    French: 'fr',
    FrenchCanada: 'fr-CA',
    German: 'de',
    Indonesian: 'id',
    Italian: 'it',
    Japanese: 'ja',
    Korean: 'ko',
    Norwegian: 'nb',
    Polish: 'pl',
    PortugueseBrazil: 'pt-BR',
    Portuguese: 'pt',
    Russian: 'ru',
    SpanishMexico: 'es-MX',
    Spanish: 'es',
    Swedish: 'sv',
    Thai: 'th',
    Turkish: 'tr',
};
exports.AppleLanguageType = {
    ...exports.LanguageType,
    Vietnamese: 'vi',
};
exports.APPLE_DEFAULT_LOCALE = 'en-US';
exports.EMPTY_TRANSLATION_TABLE = {
    $type: 'TranslationTable',
};
const isTranslationTable = (value) => {
    return ((0, utils_1.isRecord)(value) &&
        '$type' in value &&
        value['$type'] === 'TranslationTable');
};
exports.isTranslationTable = isTranslationTable;
